export const capitalized = (text: string): string => {
  return (text.charAt(0).toUpperCase() + text.slice(1)).replaceAll("_", " ");
};

export const createOption = (value: string) => {
  return {
    label: capitalized(value),
    value,
  };
};
